import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [promoteEmail, setPromoteEmail] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/customers");
      setCustomers(r.data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const promote = async (e) => {
    e.preventDefault();
    if (!promoteEmail.trim()) return;
    try {
      await api.post("/admin/admins/promote", { email: promoteEmail.trim() });
      toast.success("Promoted to admin.");
      setPromoteEmail("");
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Promote failed.");
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-customers-page">
      <div>
        <div className="eyebrow text-silver/70 mb-2">Maison</div>
        <h1 className="font-serif text-white text-3xl md:text-4xl">Customers.</h1>
      </div>

      <form onSubmit={promote} className="border border-white/8 bg-midnight p-5 flex flex-col sm:flex-row gap-3 sm:items-end">
        <div className="flex-1">
          <label className="text-[10px] tracking-[0.3em] uppercase text-silver/70">Promote Google account to admin (by email)</label>
          <input
            type="email"
            value={promoteEmail}
            onChange={(e) => setPromoteEmail(e.target.value)}
            placeholder="name@gmail.com"
            className="lux-input"
            data-testid="promote-email-input"
          />
        </div>
        <button type="submit" className="bg-white text-black px-6 py-3 text-[10px] tracking-[0.3em] uppercase hover:bg-silver" data-testid="promote-submit">
          Promote to admin
        </button>
      </form>

      {loading ? (
        <div className="text-white/50">Loading…</div>
      ) : customers.length === 0 ? (
        <div className="text-white/50">No customers yet.</div>
      ) : (
        <div className="border border-white/8 bg-midnight overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-[10px] tracking-[0.28em] uppercase text-silver/70 border-b border-white/8">
                <th className="text-left py-3 px-4">Customer</th>
                <th className="text-left py-3 px-4">Email</th>
                <th className="text-left py-3 px-4">Phone</th>
                <th className="text-left py-3 px-4">Source</th>
                <th className="text-left py-3 px-4">Joined</th>
                <th className="text-left py-3 px-4">Last login</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.user_id} className="border-b border-white/5" data-testid={`customer-row-${c.user_id}`}>
                  <td className="py-3 px-4">
                    <div className="font-serif text-white">{c.name || "—"}</div>
                    <div className="text-[10px] text-white/40">{c.user_id}</div>
                  </td>
                  <td className="py-3 px-4 text-white/70">{c.email || "—"}</td>
                  <td className="py-3 px-4 text-white/70">{c.phone || "—"}</td>
                  <td className="py-3 px-4 text-white/55 text-xs tracking-[0.2em] uppercase">{c.source || "—"}</td>
                  <td className="py-3 px-4 text-white/55 text-xs">{c.created_at ? new Date(c.created_at).toLocaleDateString() : "—"}</td>
                  <td className="py-3 px-4 text-white/55 text-xs">{c.last_login_at ? new Date(c.last_login_at).toLocaleString() : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
